import { useTranslation } from 'react-i18next';
import { UserPlus } from 'lucide-react';
import { PropertyRow } from '@/shared/components/ui/PropertyRow';
import { UserTeamSelect } from '@/shared/components/user-team-select/UserTeamSelect';
import type { UsersAndTeams } from '@momentum/types';

interface VisibleToFieldProps {
  value: UsersAndTeams;
  onChange: (value: UsersAndTeams) => void;
}

export const VisibleToField = ({ value, onChange }: VisibleToFieldProps) => {
  const { t } = useTranslation('knowledge');

  return (
    <PropertyRow
      icon={<UserPlus />}
      label={t('visibleToLabel')}
      tooltip={t('visibleToTooltip')}
    >
      <UserTeamSelect
        value={value}
        onChange={onChange}
        placeholder={t('visibleToPlaceholder')}
        teamsLabel={t('pickerTeamsGroup')}
        peopleLabel={t('pickerPeopleGroup')}
        searchPlaceholder={t('pickerSearchPlaceholder')}
        noResultsLabel={t('pickerNoResults')}
      />
    </PropertyRow>
  );
};
